<template>
  <div class="movie-box as-flex main-start cross-start">
    <div v-if="type==='multi'" class="multi-container as-flex main-center cross-center">
      <i :class="[ 'multi-select',chosen?'chosenCircle':'notchosenCircle']"></i>
    </div>
    <div class="main-box">
      <div class="title-row f-3 as-flex main-start cross-center">
        <span>{{movieInfo.movie_name||'--'}}</span>
      </div>
      <div class="type-row as-flex flex-horizontal main-start cross-center f-2">
        <div
          class="box-time"
        >{{movieInfo.movie.launch||'--:--:--'}} ({{weekMapping[movieInfo.movie.day]||'--:--:--'}})</div>
        <template v-for="(item,index) in (movieInfo.movie.tags||[])">
          <div :key="item.id" :class="['box-type',index===0?'is-first':'']">{{item.name}}</div>
        </template>
      </div>
      <div class="box-row as-flex flex-horizontal main-start cross-center f-2">
        <div class="total-box">综合票房: {{movieInfo.movie.box}}</div>
        <div class="first-week-box">首周票房: {{movieInfo.movie.first_week_box}}</div>
      </div>
      <div class="tag-row as-flex flex-horizontal main-start cross-center f-2">
        <div
          class="cycle as-flex flex-horizontal main-center cross-center f-2"
        >{{offsetMaaping[movieInfo.offset]||'-- --'}}</div>
        <template v-if="['0.0','-1.0','-2.0','-3.0','-4.0'].includes(movieInfo.offset)">
          <template v-for="item in beforeTags">
            <div :key="item.id" class="tag1">
              {{item.value}}
              <span
                :class="[movieInfo.base<50?'is-warning':'']"
              >{{movieInfo[item.id]===null?'-- --':`${Number(movieInfo[item.id]).toFixed(1)}%`}}</span>
            </div>
          </template>
        </template>
        <template v-else>
          <template v-for="item in afterTags">
            <div :key="item.id" class="tag1">
              {{item.value}}
              <span
                :class="[movieInfo.base<30?'is-warning':'']"
              >{{movieInfo[item.id]===null?'-- --':`${Number(movieInfo[item.id]).toFixed(1)}%`}}</span>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
const offsetMaaping = {
  "-1.0": "映前1周",
  "-2.0": "映前2周",
  "-3.0": "映前3周",
  "-4.0": "映前4周",
  "0.0": "上映当周",
  "1.0": "映后1周"
  // "2.0": "映后2周"
};
const weekMapping = {
  1: "周一",
  2: "周二",
  3: "周三",
  4: "周四",
  5: "周五",
  6: "周六",
  7: "周日"
};
const beforeTags = [
  { id: "awareness", value: "认知" },
  { id: "interest", value: "兴趣" },
  { id: "primary", value: "首选" },
  { id: "secondary", value: "次选" }
];
const afterTags = [
  { id: "rating", value: "喜爱" },
  { id: "recommendation", value: "推荐" },
  { id: "expectation", value: "预期达成" }
];
export default {
  name: "movieBox",
  props: {
    movieInfo: { default: {} },
    type: { default: "single" },
    chosen: false
  },
  data() {
    return {
      offsetMaaping: offsetMaaping,
      weekMapping: weekMapping,
      beforeTags: beforeTags,
      afterTags: afterTags
    };
  },
  methods: {},
  computed: {},
  create() {
    // console.log(this.movieInfo);
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
.movie-box {
  position: relative;
  height: 100%;
  width: 100%;
  padding: 10px 20px;
  background-color: #ffffff;
}
.main-box {
  width: calc(100% - 50px);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-start;
}
.multi-container {
  width: 50px;
  height: 100%;
}
.title-row {
  height: 40px;
  width: 100%;
  color: #333333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.box-row {
  height: 40px;
  width: 100%;
  color: #666666;
  white-space: nowrap;
  .total-box {
    margin-right: 10px;
  }
}
.type-row {
  height: 40px;
  width: 100%;
  color: #666666;
  white-space: nowrap;
  margin-left: -10px;
  .box-type {
    border-left: 2 solid #666666;
    // line-height: 100%;
    padding: 0 10px;
    &.is-first {
      border-left: 1px solid rgba(0, 0, 0, 0);
    }
  }
  .box-tag {
    // line-height: 100%;
    padding-right: 10px;
  }
  .box-time {
    // line-height: 100%;
    padding: 0 10px;
  }
}
.tag-row {
  height: 40px;
  width: 100%;
  white-space: nowrap;
  color: #666666;
  margin: 0px 0px;
  .cycle {
    // line-height: 100%;
    color: #fda413;
    // width: 0.94rem;
    // height: 50px;
    // border: 0.02rem solid #fda413;
    border-radius: 5px;
    margin-right: 20px;
  }
  .tag1 {
    // line-height: 100%;
    padding-right: 10px;
    margin-right: 20px;
  }
  .tag2 {
    // line-height: 100%;
    padding-right: 10px;
    margin-right: 20px;
  }
  .tag3 {
    // line-height: 100%;
    padding-right: 10px;
    margin-right: 20px;
  }
}
.multi-select {
  // position: absolute;
  // right: 0;
  // top: 50%;
  // transform: translateY(-50%);
  width: 20px;
  height: 20px;
  background-size: 100% !important;
  background-repeat: no-repeat;
  &.chosenCircle {
    background: url(../../assets/images/add-movie-active-3x.png);
  }
  &.notchosenCircle {
    background: url(../../assets/images/add-movie-not-active-3x.png);
  }
}
.is-warning {
  color: red;
}
</style>
